export default "__VITE_ASSET__brSUA9Zr__"